import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M18.992 4.904A9.84 9.84 0 0 0 11.985 2c-5.458 0-9.901 4.442-9.903 9.903a9.9 9.9 0 0 0 1.322 4.95L2 21.985l5.25-1.377a9.9 9.9 0 0 0 4.732 1.206h.005c5.457 0 9.9-4.443 9.903-9.903a9.84 9.84 0 0 0-2.899-7.006m-7.006 15.237h-.003a8.2 8.2 0 0 1-4.19-1.147l-.3-.179-3.115.817.831-3.037-.196-.312a8.2 8.2 0 0 1-1.258-4.38c.002-4.538 3.694-8.23 8.235-8.23 2.198 0 4.265.857 5.82 2.414a8.18 8.18 0 0 1 2.408 5.823c-.002 4.538-3.695 8.23-8.231 8.23zm4.515-6.164c-.247-.124-1.464-.723-1.69-.805-.227-.083-.392-.124-.557.124s-.64.805-.784.97-.288.185-.536.062c-.247-.124-1.044-.386-1.99-1.228-.735-.657-1.232-1.467-1.376-1.715-.145-.248-.016-.381.108-.504.111-.111.247-.29.371-.434s.165-.248.248-.413.041-.31-.02-.433c-.062-.124-.557-1.342-.764-1.837-.2-.483-.405-.417-.556-.425a10 10 0 0 0-.475-.009.9.9 0 0 0-.66.31c-.227.248-.866.846-.866 2.064s.887 2.395 1.01 2.56c.125.165 1.746 2.664 4.228 3.736.59.255 1.051.408 1.41.522a3.4 3.4 0 0 0 1.559.098c.475-.071 1.464-.599 1.67-1.177.206-.577.206-1.073.144-1.176-.061-.103-.227-.165-.474-.29",
      clipRule: "evenodd"
    }
  )
);
var SvgWhatsappFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var WhatsappFilled_default = SvgWhatsappFilled;

export { WhatsappFilled_default as default };
